module.exports = __webpack_public_path__ + "img/wallpaper4.fd623b25.png";